import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/login/login';
// import Register from '../pages/register/register';

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/auth/login" replace />} />
      <Route path="login" element={<Login />} />
      {/* <Route path="/register" element={<Register />} /> */}
    </Routes>
  );
};

export default AuthRoutes;